import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, inject, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { IItem } from '../../../models/IItem';
import { TimeLeftService } from '../../../services/time-left.service';
import { faBookmark as faBookmarkSolid } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FavoritesItemsService } from '../../../services/favorites/favorites-items.service';
import { AuthService, LOGIN_TYPE_TOPBAR } from '../../../services/authentication/auth.service';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { SanitizeHtmlTextPipe } from '../../../shared/pipes/sanitize-html-text.pipe';
import { DefaultImageComponent } from "../../auctions/default-image/default-image.component";



@Component({
  selector: 'app-item-horizontal-view',
  imports: [NgFor, NgIf, CommonModule, ButtonModule, FontAwesomeModule, SanitizeHtmlTextPipe, DefaultImageComponent],
  templateUrl: './item-horizontal-view.component.html',
  styleUrl: './item-horizontal-view.component.scss'
})
export class ItemHorizontalViewComponent implements OnChanges {
  protected readonly timeLeftService = inject(TimeLeftService);
  auctionId = input(0);
  @Input() items: IItem[] = [];
  @Input() isHomePage: boolean = true;
  @Output() openModal = new EventEmitter<number>();

  @Output() favoriteChanged = new EventEmitter<IItem>();

  faBookmarkSolid = faBookmarkSolid;
  faBookmarkRegular = faBookmarkRegular;

  private favoriteService = inject(FavoritesItemsService);
  private authService = inject(AuthService);

  isFavorited: boolean | null = null;
  isAuthenticatedFavorited: boolean | null = null;
  authSubscription!: Subscription;


  onOpenModalHorizontal(id: number) {
    this.openModal.emit(id);
    // console.log('into emmiter', id);
  }

  ngOnInit(): void {
    // console.log('items in horizontal view', this.items);
    this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
      if (isAuth) {
        this.isAuthenticatedFavorited = true;

      } else {
        this.isAuthenticatedFavorited = false;

      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      // console.log(this.items)
    }
  }

  itemFavorite(item: IItem) {

    if (!this.isAuthenticatedFavorited) {
      this.openLoginModalFavorite()
      return;
    }
    // console.log(item.id!)
    this.favoriteService.putFavorite(item.id!).subscribe({
      next: (reponse) => {
        // console.log('favorite responde', reponse)
        item.isFavorite = !item.isFavorite;
        this.favoriteChanged.emit(item);
      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    })
  }

  removeItemFavorite(item: IItem) {
    if (!this.isAuthenticatedFavorited) {
      this.openLoginModalFavorite()
      return;
    }

    this.favoriteService.deleteFavorite(item.id!).subscribe({
      next: (reponse) => {
        // console.log('remove', reponse)
        item.isFavorite = !item.isFavorite;
        this.favoriteChanged.emit(item);
      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    })
  }

  toggleFavorite(item: IItem): void {
    // console.log(item.isFavorite);
    if (item.isFavorite) {
      this.removeItemFavorite(item);
    }
    else {
      this.itemFavorite(item);
    }
  }

  openLoginModalFavorite() {
    this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, function () { }, this.auctionId());

  }

  isAmountEstimatedValue(value: string): boolean {
    const numeric = value.replace(/[^0-9.-]+/g, '');
    return numeric.trim() !== '' && !isNaN(Number(numeric));
  }


}
